import { useContext } from "react";

import { NotificationsProvider } from "./notification-component.context.lib";
import { NotificationContext } from "./notification.context.lib";

const useNotification = () => useContext(NotificationContext);

export default NotificationsProvider;
export { useNotification };
